<template>
  <div class="d-flex align-top px-3 py-2">
    <div>
      <div class="mr-2 font-weight-regular oc-text-shadow">
        {{ user.name }}
      </div>
      <div
        v-if="user.specialty"
        class="font-weight-light oc-text-shadow"
         style="line-height: .8"
      >
        <small>{{ user.specialty.name }}</small>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'

@Component({
  props: {
    apiKeyVP8: {
      type: String,
      default: process.env.VUE_APP_OT_APIKEY_VP8
    }
  },
  computed: {
    user () {
      return this.$store.state.storage.room.cammer.user
    }
  }
})
export default class SubscriberInfo extends Vue {}
</script>

<style>
  .oc-text-shadow {
    text-shadow: 1px 1px 3px #000;
  }
</style>